module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, _vm._l((_vm.layout), function(octave) {
    return _c('div', {
      staticClass: "bands",
      style: (octave.config)
    }, _vm._l((octave.bands), function(band, index) {
      return _c('div', {
        style: ([band.base, _vm.active[band.index] ? band.transitionIn : band.transitionOut])
      })
    }))
  }))
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2340cccc"}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/components/player/overlay.vue
// module id = 270
// module chunks = 1